import React, { FunctionComponent } from 'react';
import { AsyncLoading, SpacingName } from '@doveit/lego';
import CardsHList from '../../components/cards-hlist/CardsHList';
import useLatestSoldProperties from '../../hooks/useSoldProperties/useSoldProperties';
import SoldPropertyCard from '../../components/sold-property-card/SoldPropertyCard';

export interface ViewLatestSoldPropertiesProps {
  size?: number,
  sideSpacing?: SpacingName,
}

const ViewLatestSoldProperties: FunctionComponent<ViewLatestSoldPropertiesProps> = ({
  size = 4,
  sideSpacing,
}) => {
  const { data, error } = useLatestSoldProperties({}, { size });

  return (
    <AsyncLoading
      isLoading={!data && !error}
      errorMessage={error && 'Errore durante il caricamento'}
    >
      {data && (
        <CardsHList sideSpacing={sideSpacing}>
          {data.map((searchResult) => (
            <CardsHList.Item key={searchResult.id}>
              <SoldPropertyCard
                title={`${searchResult.locality}${(searchResult.suburb ? ` - ${searchResult.suburb}` : '')}`}
                saving={searchResult.savingLabel}
                image={searchResult.coverImageSet.small}
                banner={searchResult.soldLabel}
              />
            </CardsHList.Item>
          ))}
        </CardsHList>
      )}
    </AsyncLoading>
  );
};

export default ViewLatestSoldProperties;
